{
  "acsSlow": {
    "body": "Zur Autorisierung der Transaktion verbinden wir dich mit dem Anbieter deiner Zahlungsmethode.",
    "title": "Warten auf Antwort deiner Bank..."
  },
  "app": {
    "title": "Zahlungsaufforderungen begleichen – pagoPA"
  },
  "ariaLabels": {
    "appLanguage": "Sprache einstellen",
    "close": "Schließen",
    "editCard": "Karteninformationen ändern",
    "editDonation": "Spendenorganisation ändern",
    "editPsp": "Zahlungsdienstleister ändern",
    "informationDialog": "Informationen zu den Kommissionsgebühren",
    "informationLink": "Weitere Informationen zum Programm",
    "languageMenu": "Eingestellte Sprache",
    "loading": "Laden...",
    "applySorting": "Gewählte Reihenfolge anwenden",
    "sortingDefault": "Standardsortierung",
    "sortingName": "Sortierung nach Name",
    "sortingAmount": "Sortierung nach Betrag"
  },
  "cancelledPage": {
    "body": "Der Vorgang wurde abgebrochen",
    "button": "Schließen"
  },
  "authCallbackPage": {
    "title": "Es war nicht möglich sich anzumelden",
    "body": "Beim Zugriff ist ein Problem aufgetreten. Versuch es in ein paar Minuten nochmal",
    "buttons": {
      "retry": "Versuch es nochmal",
      "continueWithoutLogin": "Weiter ohne Anmeldung"
    }
  },
  "authExpiredPage": {
    "title": "Deine Sitzung ist abgelaufen",
    "body": "Melde dich an, um die Sitzung fortzusetzen, oder fahre ohne Anmeldung fort",
    "buttons": {
      "login": "Anmelden",
      "continueWithoutLogin": "Weiter ohne Anmeldung"
    }
  },
  "cartDetail": {
    "amount": "Betrag",
    "companyName": "Zahlungsempfänger",
    "description": "Verwendungszweck",
    "fiscalCode": "Steuernummer des Empfängers",
    "iuv": "IUV-Code",
    "noticeNumber": "Zahlungsaufforderungsnr."
  },
  "clipboard": {
    "copied": "Kopiert",
    "copy": "Kopieren",
    "edit": "Ändern"
  },
  "DOMAIN_UNKNOWN": {
    "title": "Die empfangende Behörde hat Probleme mit der Antwort",
    "buttons": {
      "close": "Schließen",
      "help": "Kontakt mit Kundendienst"
    }
  },
  "DONATIONLIST_ERROR": "Wir konnten die Liste der Organisationen nicht laden.",
  "donationPage": {
    "click": "drücke",
    "code": "und scanne den Code: ",
    "description": "Du hast Zeit bis zum 23. Dezember. Du kannst gebührenfrei mit der Karte spenden. Der Betrag wird direkt an das Konto der gewählten Spendenorganisation überwiesen.",
    "dismissCTA": "Siehe Organisationen",
    "dismissDescription": "Wenn du möchtest, kannst du an eine der Hilfsorganisationen spenden, die am Programm teilnehmen.",
    "dismissTitle": "Der Service ist nicht mehr verfügbar",
    "entity": "Wem möchtest du spenden?",
    "ioDescription": "Bei Spenden über die IO-App erhältst du eine E-Mail mit den für Steuerzwecke benötigten Angaben.",
    "modalBody2": "Mit deinen Karten kannst du gebührenfrei spenden.",
    "modalTitle": "Weiter mit IO-App",
    "openSection": "Bereich öffnen",
    "payNotice": "Zahlungsaufforderung begleichen",
    "portfolio": "Wallet",
    "submitCard": "Mit Karte spenden",
    "submitIO": "Mit IO spenden",
    "title": "Für Ukraine-Krisenhilfe spenden",
    "volunteer": "Wie viel möchtest du spenden?"
  },
  "errorButton": {
    "close": "Schließen",
    "help": "Kontaktiere den Kundendienst",
    "retry": "Erneut versuchen"
  },
  "ErrorCodeDescription": "Fehlercode für den Kundendienst",
  "GENERIC_ERROR": {
    "body": "Versuche es noch einmal oder wende dich an den Kundendienst.",
    "title": "Ein unvorhergesehener Fehler ist aufgetreten"
  },
  "general": {
    "and": "und"
  },
  "indexPage": {
    "description": "Du kannst deine Karte, dein Konto oder eine Zahlungs-App verwenden. Du erhältst eine E-Mail über den Ausgang der Zahlung.",
    "title": "Zahlungsaufforderung begleichen"
  },
  "iframeCardPage": {
    "helpLink": "Wo finde ich den CVV?",
    "modalTitle": "Wo finde ich den CVV?",
    "modalBodyText": "Der CVV Code (oder CVC) besteht aus 3 Ziffern und befindet sich auf der Rückseite deiner Karte.<br>Bei American Express-Karten hat der Code (CID) 4 Ziffern und befindet sich auf der Vorderseite.",
    "buttonClose": "Schließen"
  },
  "inputCardPage": {
    "formErrors": {
      "cid": "Vier Ziffern eingeben",
      "cvv": "3 Ziffern eingeben",
      "expirationDate": "MM/JJ eingeben",
      "name": "Genau wie auf der Karte eingeben",
      "number": "Gültige Nummer eingeben",
      "required": "Pflichtfeld"
    },
    "formFields": {
      "cid": "CID (vier Ziffern)",
      "cvv": "CVV",
      "expirationDate": "Gültig bis",
      "name": "Karteninhaber",
      "number": "Kartennummer",
      "required": "Pflichtfeld"
    },
    "helpLink": "Wo finde ich den Sicherheitscode?",
    "modal": {
      "description": "Den dreistelligen Code CVV oder CVS findest du auf der Kartenrückseite.",
      "descriptionAE": "Bei American Express besteht der Code (CID) aus vier Ziffern und befindet sich auf der Vorderseite.",
      "title": "Sicherheitscode"
    },
    "title": "Gib die Karteninformationen ein"
  },
  "INVALID_CARD": {
    "body": "Versuche es mit einer gültigen Karte oder wende dich an uns, wenn du Hilfe brauchst.",
    "title": "Leider ist die Karte nicht gültig"
  },
  "INVALID_DECODE": {
    "body": "Versuche es noch einmal oder wende dich an uns, wenn du Hilfe brauchst.",
    "title": "Fehler beim Lesen der Daten"
  },
  "INVALID_QRCODE": {
    "body": "Wenn das Problem bestehen bleibt, gib die Daten manuell ein.",
    "title": "Der gescannte Code ist keine Zahlungsaufforderung für pagoPA"
  },
  "koPage": {
    "body": "Es ist keine Belastung erfolgt.",
    "button": "Schließen",
    "helpButton": "Brauchst du Hilfe?",
    "learnMoreButton": "Mehr erfahren",
    "title": "Ein unvorhergesehener Fehler ist aufgetreten"
  },
  "mainPage": {
    "footer": {
      "accessibility": "Barrierefreiheit",
      "help": "Hilfe",
      "privacy": "Datenrichtlinie",
      "terms": "Nutzungsbedingungen",
      "platformStatus": "Plattformstatus",
      "pagoPA": "Website von pagoPA aufrufen"
    },
    "header": {
      "login": "Anmelden",
      "logout": "Abmelden",
      "detail": {
        "detailButton": "Zahlungsübersicht öffnen",
        "detailFC": "Steuernummer des Empfängers",
        "detailIUV": "IUV-Code",
        "detailAmount": "Zwischensumme",
        "detailReceiver": "Zahlungsempfänger",
        "detailSubject": "Verwendungszweck",
        "detailTitle": "Daten der Zahlungsaufforderung"
      },
      "disclaimer": "Der Betrag wird automatisch aktualisiert, damit du stets den zu zahlenden Betrag begleichst und Verzugsgebühren oder Zinsen vermeidest."
    },
    "main": {
      "skipToContent": "Zum Hauptinhalt springen"
    }
  },
  "NOTLISTED": {
    "body": "Versuche es noch einmal oder wende dich an uns, wenn du Hilfe brauchst.",
    "title": "Ein unvorhergesehener Fehler ist aufgetreten"
  },
  "PAYMENT_CANCELED": {
    "body": "Bitte die Behörde um weitere Informationen.",
    "title": "Der Zahlungsempfänger hat diese Zahlungsaufforderung aufgehoben"
  },
  "PAYMENT_DATA_ERROR": {
    "title": "Die Daten der Zahlungsaufforderung sind falsch"
  },
  "PAYMENT_DUPLICATED": {
    "body": "Wenn du über diese Website bezahlt hast, wurde die Bestätigung an die E-Mail-Adresse gesendet, die du bei der Zahlung angegeben hast.",
    "title": "Diese Zahlungsaufforderung wurde bereits beglichen!"
  },
  "PAYMENT_EXPIRED": {
    "body": "Bitte die Behörde um weitere Informationen.",
    "title": "Die Zahlungsaufforderung ist abgelaufen und kann nicht mehr beglichen werden"
  },
  "PAYMENT_ONGOING": {
    "body": "Wenn das Problem bestehen bleibt, melde es uns bitte!",
    "title": "Es ist bereits eine Zahlung in Bearbeitung. Versuche es später noch einmal"
  },
  "PAYMENT_UNAVAILABLE": {
    "title": "Technisches Problem mit dieser Zahlungsaufforderung"
  },
  "PAYMENT_UNKNOWN": {
    "body": "Die Zahlungsaufforderung könnte bereits bezahlt worden sein. Für Unterstützung kontaktieren Sie bitte die Zahlungsempfänger.",
    "title": "Der Zahlungsaufforderung konnte nicht gefunden werden"
  },
  "pspUnavailable": {
    "body": "Dieser Fehler kann auftreten, wenn der zu zahlende Betrag besonders hoch ist, oder wenn versucht wird, eine digitale Steuermarke zu bezahlen.",
    "cta": {
      "primary": "Wählen eine andere Zahlungsmethode"
    },
    "title": "Die gewählte Zahlungsmethode ist nicht verfügbar"
  },
  "paymentEmailPage": {
    "description": "Du erhältst die Zahlungsbestätigung an diese E-Mail-Adresse",
    "formButtons": {
      "back": "Zurück",
      "submit": "Weiter"
    },
    "formErrors": {
      "invalid": "Gib eine gültige E-Mail-Adresse ein",
      "notEqual": "Die E-Mail-Adressen stimmen nicht überein",
      "required": "Pflichtfeld"
    },
    "formFields": {
      "confirmEmail": "Wiederholen",
      "email": "E-Mail-Adresse"
    },
    "title": "Gib deine E-Mail-Adresse ein"
  },
  "findOutMoreModal": {
    "title": "Was tun, wenn die Zahlung nicht erfolgreich ist?",
    "section1Title": "1. Bezahle die Zahlungsaufforderung",
    "section1ContentRow1": "Denke daran, die Zahlungsaufforderung innerhalb der vom Amt festgelegten Fristen zu bezahlen.",
    "section1ContentRow2": "Wenn du es über diese Seite nicht schaffst, ",
    "section1ContentRow2Link": "entdecke die anderen über pagoPA verfügbaren Kanäle.",
    "section2Title": "2. Warte auf die Rückerstattung",
    "section2ContentRow1": "In der Regel wird der Betrag innerhalb weniger Minuten gutgeschrieben.",
    "section2ContentRow2": "In anderen Fällen kann die Überweisung auf dein Konto oder deine Karte länger dauern.",
    "section3Title": "3. Kontaktiere den Support",
    "section3ContentRow1": "Wenn du nach 5 Werktagen die Rückerstattung noch nicht erhalten hast, ",
    "section3ContentRow2Link": "kontaktiere den Support."
  },
  "paymentResponsePage": {
    "0": {
      "body": "Wir haben den Zahlungsbestätigung an {{useremail}} gesendet",
      "title": "Du hast {{amount}} bezahlt"
    },
    "1": {
      "body": "Es ist keine Belastung erfolgt.",
      "title": "Ein unvorhergesehener Fehler ist aufgetreten."
    },
    "2": {
      "body": "Es ist keine Belastung erfolgt. Vergewissere dich, dass du die Anweisungen deiner Bank richtig befolgt hast.",
      "title": "Autorisierung nicht erfolgt"
    },
    "3": {
      "body": "Wenn du mit einer Debit- oder Kreditkarte bezahlst, achte darauf, die Daten genau wie auf der Kartenvorderseite einzugeben.",
      "title": "Die Daten der Zahlungsmethode sind falsch"
    },
    "4": {
      "body": "Es ist keine Belastung erfolgt. Zu deiner Sicherheit ist die Zeit für diesen Vorgang begrenzt.",
      "title": "Die Sitzung ist abgelaufen"
    },
    "5": {
      "title": "Dieser Kreditkartenanbieter wird nicht unterstützt"
    },
    "6": {
      "title": "Für die Zahlung fehlen noch einige Angaben"
    },
    "7": {
      "body": "Bitte deine Bank um weitere Informationen.",
      "title": "Die Zahlungsmethode ist abgelaufen oder nicht mehr gültig"
    },
    "8": {
      "body": "Es ist keine Belastung erfolgt.",
      "title": "Der Vorgang wurde abgebrochen"
    },
    "10": {
      "body": "Es ist keine Belastung erfolgt. Möglicherweise hast du das von deiner Bank vorgegebene Limit überschritten.",
      "title": "Autorisierung nicht erfolgt"
    },
    "12": {
      "title": "Die Zahlungsmethode wird nicht unterstützt"
    },
    "17": {
      "body": "Du erhältst eine Zahlungsbestätigung an die E-Mail-Adresse {{useremail}}.",
      "title": "Warte auf die Zahlungsbestätigung"
    },
    "18": {
      "body": "Der autorisierte Betrag wurde auf deine Zahlungsmethode zurückerstattet. Die Überweisung kann einige Zeit in Anspruch nehmen.",
      "title": "Die Zahlung war nicht erfolgreich"
    },
    "25": {
      "body": "Es wurde kein Betrag belastet.\n Wenn das Problem weiterhin besteht, versuche es mit einer anderen Zahlungsmethode oder einem anderen Zahlungsanbieter.",
      "title": "Die Zahlung war nicht erfolgreich"
    },
    "116": {
      "body": "Es wurde kein Betrag belastet. Bevor du es erneut versuchst, lade Guthaben auf deine Karte oder nutze eine andere Zahlungsmethode.",
      "title": "Der Kontostand deiner Karte ist nicht ausreichend."
    },
    "117": {
      "body": "Es wurde kein Betrag belastet. Der Code (CVV oder CVC) besteht aus 3 Ziffern und befindet sich auf der Rückseite der Karte. Wenn du American Express benutzt, hat der Code (CID) 4 Ziffern und befindet sich auf der Vorderseite.",
      "title": "Der eingegebene Sicherheitscode ist falsch"
    },
    "121": {
      "body": "Es wurde kein Betrag belastet. Bevor du es erneut versuchst, ändere das Ausgabelimit oder nutze eine andere Zahlungsmethode.",
      "title": "Du hast das Ausgabelimit deiner Karte überschritten."
    },
    "3dsNotInitiated": {
      "body": "Es ist keine Belastung erfolgt.\nWenn das Problem bestehen bleibt, wende dich an den Anbieter deiner Zahlungsmethode, z. B. deine Bank.",
      "title": "Es ist ein Problem mit dem Anbieter deiner Zahlungsmethode aufgetreten"
    },
    "buttons": {
      "continue": "Weiter",
      "findOutMode": "Mehr erfahren"
    },
    "survey": {
      "body": "Teile uns deine Benutzererfahrung mit der Zahlung mit und hilf uns, besser zu werden.",
      "link": {
        "href": "https://pagopa.qualtrics.com/jfe/form/SV_0jllXJcXhmSpb38",
        "text": "Weiter zur Umfrage"
      },
      "title": "Sagst du uns bitte, wie es gelaufen ist?"
    }
  },
  "paymentCheckPage": {
    "buttons": {
      "cancel": "Abbrechen",
      "submit": "Bezahlen",
      "wait": "Bitte warten..."
    },
    "creditCard": "Bezahlen mit",
    "disclaimer": {
      "cheaper": "Vorgeschlagen, weil kostengünstigste Möglichkeit",
      "yourCard": "Vorgeschlagen, weil du bereits Kunde bist",
      "psp": "Mit dem Fortfahren akzeptieren <terms>Sie die Nutzungsbedingungen und bestätigen</terms> die <privacy>Datenschutzerklärung</> von <psp>{{pspName}}</psp> gelesen zu haben."
    },
    "drawer": {
      "body": "Hier sind alle mit deiner Methode kompatiblen Anbieter aufgelistet, auch wenn du nicht Kunde bei ihnen bist.",
      "header": {
        "amount": "Gebühr",
        "name": "Anbieter"
      },
      "title": "Über welchen Anbieter möchtest du zahlen?",
      "selectPspAccessibilityLabel": "{{pspName}} als Zahlungsanbieter auswählen",
      "pspNameAccessibilityLabel": "Alphabetisch nach dem Namen des Anbieters sortieren",
      "taxFeeAccessibilityLabel": "Von der niedrigsten Gebühr aufsteigend sortieren"
    },
    "email": "Sende Bestätigung an:",
    "modal": {
      "body": "Jeder Geldtransfer (Bargeld oder elektronisches Geld) ist mit Kosten verbunden, die gewährleisten, dass die Zahlung sicher und erfolgreich ist.\nJeder Anbieter (oder PSP, Payment Service Provider) erhebt Kosten, die von seiner eigenen Geschäftspolitik und seinen Vertragsbedingungen abhängen.\nMit pagoPA sind diese Kosten transparent und der Bürger kann die bequemste und günstigste Option frei wählen. Weitere Informationen findest du auf der Seite ",
      "cancelBody": "Wenn du dich jetzt beendest, gehen alle bisher eingegebenen Daten verloren und du musst von vorne anfangen.",
      "cancelButton": "Nein, ich habe es mir anders überlegt",
      "cancelTitle": "Deine Zahlung ist in Bearbeitung. Bist du sicher, dass du dich beenden möchtest?",
      "link": "Kostentransparenz",
      "submitButton": "Beenden",
      "title": "Weshalb fallen Gebühren an?"
    },
    "psp": "Erhoben von",
    "total": "Gesamt",
    "transaction": "Gebühr"
  },
  "paymentChoicePage": {
    "saved": "Gespeicherte",
    "bank": "Bankkonto",
    "button": "Zurück",
    "costs": "Kostentransparenz.",
    "creditCard": "Kredit- und Debitkarten",
    "description": "Mehr über die Methoden und Gebühren der teilnehmenden Anbieter erfährst du auf der Seite ",
    "incoming": "Eingang",
    "others": "Sonstige Methoden",
    "showMore": "Nicht verfügbare Methoden",
    "title": "Wie möchtest du zahlen?",
    "feeRange": "Gebühr: von {{min}}  bis {{max}}",
    "feeSingle": "Gebühr: {{value}}",
    "filterLabel": "Methode suchen",
    "noPaymentMethodsAvailable": "Kein Ergebnis gefunden. Versuch es mit einem anderen Begriff.",
    "filterButton": "Filtern",
    "drawer": {
      "title": "Zahlungsarten filtern",
      "byType": "Nach Typ",
      "byFunc": "Nach Funktionalität",
      "card": "Karte",
      "balance": "Bankkonto",
      "appApm": "Apps und andere Methoden",
      "payByPlan": "Ratenzahlung",
      "showResults": "Ergebnisse anzeigen",
      "remove": "Alle Filter löschen"
    }
  },
  "paymentMethods": {
    "bpay": "BANCOMAT Pay",
    "cc": "Bankkonto",
    "cp": "Kredit- und Debitkarten",
    "ppay": "Zahle mit Postepay"
  },
  "paymentNoticeChoice": {
    "form": {
      "description": "Zahlungsaufforderungsnr. und Steuernr. Körperschaft",
      "title": "Du gibts die Daten ein"
    },
    "qr": {
      "description": "Webcam oder Kamera verwenden",
      "title": "QR-Code scannen"
    }
  },
  "paymentNoticePage": {
    "description": "Übernimm die Angaben aus der Zahlungsaufforderung.",
    "exampleModalAltText": "Zahlungsaufforderung über pagoPA, mit hervorgehobenem Abschnitt, in dem der Zahlungscode und die Steuernummer der empfangenden Stelle angegeben sind",
    "exampleModalTitle": "Beispiel einer pagoPA-Zahlungsaufforderung",
    "formButtons": {
      "cancel": "Zurück",
      "submit": "Weiter"
    },
    "formErrors": {
      "minCf": "11 Ziffern eingeben",
      "minCode": "18 Ziffern eingeben",
      "required": "Pflichtfeld"
    },
    "formFields": {
      "billCode": "Zahlungsaufforderungsnr.",
      "cf": "Steuernummer des Empfängers"
    },
    "helpLink": "Beispiel anzeigen",
    "title": "Was musst du bezahlen?"
  },
  "paymentPspListPage": {
    "title": "Wählen Sie, wer die Zahlung verwalten wird",
    "description": "Jeder Anbieter erhebt eine Gebühr. In dieser Liste finden Sie alle kompatiblen Anbieter, <strong>auch wenn Sie kein Kunde von ihnen sind</strong>.",
    "operator": "Anbieter",
    "alreadyClient": "Sie bereits Kunde",
    "formButtons": {
      "back": "Zurück",
      "submit": "Weiter"
    },
    "sort": "Sortieren",
    "drawer": {
      "sorting": {
        "default": "Standard",
        "name": "Nach Name",
        "amount": "Nach Betrag"
      },
      "showResults": "Anwenden"
    },
    "myBankAlertTitle": "Findest du deine Bank nicht?",
    "myBankAlertBody": "Keine Sorge: Du wählst sie in den nächsten Schritten aus."
  },
  "paymentQrPage": {
    "camBlocked": "Wir benötigen deine Erlaubnis zum Zugriff auf die Kamera. In den Datenschutzeinstellungen deines Internetbrowsers kannst du die Auswahl ändern",
    "description": "Achte auf gute Beleuchtung. Wenn der Code unscharf ist, halte ihn etwas weiter vom Bildschirm weg.",
    "navigate": "Funktioniert es nicht? Von Hand eingeben",
    "reloadPage": "Seite neu laden",
    "title": "QR-Code scannen",
    "usageHintPc": "Diese Seite erfordert die Verwendung eines QR-Code-Scanners. Um den QR-Code zu scannen, erlaube dem Browser den Zugriff auf die Kamera, wenn du dazu aufgefordert wirst. Du musst möglicherweise eine externe oder integrierte Webcam verwenden. Der QR-Code sollte gut im Bild und ausreichend beleuchtet sein, um das Lesen zu erleichtern.",
    "usageHintMobile": "Diese Seite erfordert die Verwendung eines QR-Code-Scanners. Um den QR-Code zu scannen, erlaube dem Browser den Zugriff auf die Kamera, wenn du dazu aufgefordert wirst. Verwende die Rückkamera deines Smartphones und richte sie auf den QR-Code. Der QR-Code sollte gut im Bild und ausreichend beleuchtet sein, um das Lesen zu erleichtern."
  },
  "paymentSummaryPage": {
    "amount": "Aktualisierter Betrag",
    "billCode": "Zahlungsaufforderungsnr.",
    "buttons": {
      "cancel": "Zurück",
      "ok": "Okay, geht in Ordnung",
      "submit": "Weiter zur Zahlung"
    },
    "causal": "Verwendungszweck",
    "cf": "Steuernummer des Empfängers",
    "creditor": "Zahlungsempfänger",
    "description": "Wenn sich der Betrag ändert, bedeutet das, dass er automatisch aktualisiert wurde. Falls er höher ist, können Zinsen, Strafen oder Benachrichtigungskosten anfallen.\n\nHandelt es sich bei der pagoPA-Mitteilung um eine rechtlich relevante Kommunikation, kann die Erhöhung des zu zahlenden Betrags verschiedene Gründe haben, zum Beispiel:\n• wenn du die Mitteilung per Einschreiben erhalten hast (die Druck- und Versandkosten können zu deinen Lasten gehen);\n• die Anzahl der Zustellversuche.\n\nFür weitere Details wende dich bitte an die Gläubigerinstitution.",
    "dialog": {
      "description": "Wenn sich der Betrag ändert, bedeutet das, dass er automatisch aktualisiert wurde. Falls er höher ist, können Zinsen, Strafen oder Benachrichtigungskosten anfallen.\n\nHandelt es sich bei der pagoPA-Mitteilung um eine rechtlich relevante Kommunikation, kann die Erhöhung des zu zahlenden Betrags verschiedene Gründe haben, zum Beispiel:\n• wenn du die Mitteilung per Einschreiben erhalten hast (die Druck- und Versandkosten können zu deinen Lasten gehen);\n• die Anzahl der Zustellversuche.\n\nFür weitere Details wende dich bitte an die Gläubigerinstitution.",
      "title": "Ist der Betrag anders als auf der pagoPA-Benachrichtigung?"
    },
    "iuv": "IUV-Code",
    "title": "Zahlungsdaten"
  },
  "POLLING_SLOW": {
    "body": "Bitte warte, ohne die Seite neu zu laden. Es dauert höchstens ein paar Minuten.",
    "title": "Die Behörde braucht länger als erwartet..."
  },
  "privacyInfo": {
    "googleDesc": "Formular geschützt durch reCAPTCHA und Google.",
    "privacyDesc": "Durch die weitere Nutzung des Dienstes erklärst du dich mit den <terms>Nutzungsbedingungen</terms> einverstanden und bestätigst, die <privacy>Hinweise zum Datenschutz</privacy> gelesen zu haben.",
    "privacyDonation": "zusätzlichen Nutzungsbedingungen des Spendendienstes zugunsten der Krisenhilfe für die Ukraine gelesen zu haben "
  },
  "STATUS_ERROR": {
    "body": "Wenn das Problem bestehen bleibt, melde es uns bitte!",
    "title": "Ein unvorhergesehener Fehler ist aufgetreten"
  },
  "TIMEOUT": {
    "body": "Wenn das Problem bestehen bleibt, melde es uns bitte!",
    "title": "Die empfangende Behörde hat Probleme mit der Antwort"
  },
  "errorMessageNPG": {
    "HF0001": "3 oder 4 Ziffern eingeben",
    "HF0002": "Dienst vorübergehend nicht verfügbar",
    "HF0003": "Die Sitzung ist abgelaufen, geh zurück und versuch es noch einmal",
    "HF0004": "Gültige Nummer eingeben",
    "HF0005": "Das Netzwerk dieser Karte wird nicht unterstützt",
    "HF0006": "MM/JJ eingeben",
    "HF0007": "Genau wie auf der Karte eingeben",
    "HF0009": "3DS-Überprüfung fehlgeschlagen"
  },
  "userSession": {
    "logoutModal": {
      "title": "Bist du sicher, dass du dich abmelden möchtest?",
      "body": "Du kannst trotzdem bezahlen, auch wenn du nicht eingeloggt bist.",
      "submitButton": "Abmelden",
      "cancelButton": "Abbrechen"
    }
  },
  "ScheduledMaintenanceBanner": {
    "titleKey": "Geplante Wartung",
    "bodyKey": "Es wird nicht möglich sein, Zahlungen zwischen 00:01 und 03:00 am 18. Juli 2025 vorzunehmen.",
    "linkTextKey": "Weitere Informationen"
  },
  "maintenancePage": {
    "title": "Wir arbeiten für dich",
    "subtitle": "pagoPa ist derzeit aufgrund geplanter Wartungsarbeiten nicht verfügbar.",
    "closeButton": "Schließen",
    "detailsButton": "Mehr erfahren"
  },
  "__variant-name": "Tedesco",
  "__variant-description": ""
}